import { Box, BoxProps, ColorOptions, Icon, Text, TextProps } from '@jfs/ui-new'
import { useState } from 'react'
import ReactDOM from 'react-dom'
import { Dimensions, View, ViewStyle } from 'react-native'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'

interface TooltipViewProps {
  value: any
  top: number
  iconSize?: number
  fontSize?: number
  iconColor?: ColorOptions
}

const TooltipView = ({ value, top, iconSize = 8, iconColor = 'DARK_GREY', fontSize = 8 }: TooltipViewProps) => {
  const [toolTipInfo, setToolTipInfo] = useState({ visible: false, top: 0, right: 0, left: 0 })
  const [layoutEvent, setLayoutEvent] = useState<any>({})

  const renderTooltip = () => {
    const width = Dimensions.get('window').width
    const left = width - toolTipInfo.left < 100 ? toolTipInfo.left - 120 : toolTipInfo.left
    const style = {
      marginLeft: width - toolTipInfo.left < 100 ? 128 : 10,
    }
    return (
      <Box testID="tooltip-view" top={toolTipInfo.top} left={left} position={'absolute'} maxWidth={150} zIndex={1}>
        <Box bg={'BLACK'} borderRadius={4} p={4}>
          <Text {...styles.text} fontSize={fontSize}>
            {value}
          </Text>
        </Box>
        <View style={[styles.triangle, style]} />
      </Box>
    )
  }
  return (
    <>
      <Box
        paddingLeft={6}
        underlayColor="TRANSPARENT"
        onLayout={(event: any) => {
          setLayoutEvent(event.nativeEvent)
          setToolTipInfo({
            ...toolTipInfo,
            top: event.nativeEvent.layout?.top + 20,
            left: event.nativeEvent.layout?.left,
          })
        }}
        onHover={(hovered: any) => {
          layoutEvent?.target?.measure((...args: any) => {
            setToolTipInfo({ ...{ ...toolTipInfo, top: args[5] + top - 42, left: args[4] }, visible: hovered })
          })
        }}
        testID="show-tooltip"
        onPress={() => {
          setToolTipInfo({ ...toolTipInfo, visible: !toolTipInfo.visible })
        }}>
        <Icon id="INFO" size={iconSize} color={iconColor as ColorOptions} />
      </Box>
      <ModBox show={toolTipInfo.visible} position="absolute">
        {ReactDOM.createPortal(renderTooltip(), document.body)}
      </ModBox>
    </>
  )
}

const styles = {
  shadowStyle: {
    position: 'absolute',
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 2,
    shadowColor: 'GREY_MATTE',
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'BRAND_COLOR_GRAY_3',
    zIndex: 5,
    backgroundColor: 'WHITE',
    padding: 16,
  } as BoxProps,
  text: {
    fontSize: 8,
    color: 'WHITE',
    fontFamily: 'jiotype-medium',
  } as TextProps,
  triangle: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderColor: 'blue',
    borderLeftWidth: 4,
    borderRightWidth: 4,
    borderBottomWidth: 4,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: 'BLACK_21',
    marginLeft: 4,
    transform: [{ rotate: '180deg' }],
  } as ViewStyle,
}

export { TooltipView }
